module.exports = __webpack_public_path__ + "f2545c565b2a5fe583e18a0fc7adcb4b.fbx";